import html2canvas from "html2canvas";
var echarts = require("echarts");
export default {
  data() {
    return {
      selected: "7",
      StartDate: "",
      EndDate: "",
      customers: [],
      CustomerId: "",
      WHSummaryList: [],
      TotalCount: 0,
      TotalWeight: 0,
      TotalCube: 0,
      TotalPercent: 0,
      TotalCW: 0,
      CustomerName: "",
      loading: false,
      ExpRemark: ""
    };
  },

  mounted() {
    this.EndDate = new Date();
    this.StartDate = new Date().addDays(-7);
    var user = sessionStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      this.LoginName = user.LoginName;
    }
    this.getcustomers();
  },
  methods: {
    handlesearch() {
      this.DatePeriod =
        this.StartDate.Format("yyyy-MM-dd") +
        " ~ " +
        this.EndDate.Format("yyyy-MM-dd");
      console.log(this.DatePeriod);
      this.LoadData();
    },
    getcustomers() {
      var me = this;
      var user = sessionStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
      }
      var getMethod = "Customer/GetCustomerList/" + user.TokenId;

      this.$axios
        .get(getMethod)
        .then(response => {
          if (response.status === 200) {
            me.customers = response.data;
          } else {
            var strMsg = "";
            response.data.Messages.forEach(element => {
              strMsg += element.Message + "\r\n";
            });

            this.alert(strMsg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    LoadSelectedData() {
      if (this.selected == "7") {
        this.Load7Days();
      } else if (this.selected == "30") {
        this.Load30Days();
      } else if (this.selected == "90") {
        this.Load90Days();
      }
    },
    Load7Days() {
      this.LoadDays(7);
    },
    Load30Days() {
      this.LoadDays(30);
    },
    Load90Days() {
      this.LoadDays(90);
    },
    LoadDays(days) {
      this.EndDate = new Date();
      this.StartDate = new Date().addDays(-days);

      this.DatePeriod =
        this.StartDate.Format("yyyy-MM-dd") +
        " ~ " +
        this.EndDate.Format("yyyy-MM-dd");
      console.log(this.DatePeriod);
      this.LoadData();
    },
    LoginOut() {
      localStorage.removeItem("CurrentUser");
      localStorage.removeItem("CurrentUserPwd");

      sessionStorage.removeItem("user");
      this.$router.push("/Login");
    },
    LoadData() {
      this.loading = true;
      if (
        this.CustomerId == undefined ||
        this.CustomerId == "" ||
        this.CustomerId == null
      ) {
        this.alert("请选择客户");
        return;
      }
      var me = this;
      var user = sessionStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
      }
      var getLogsMethod = "BusinessTrans/gettranswaresummary";

      this.$axios
        .get(getLogsMethod, {
          params: {
            tokenid: user.TokenId,
            account: user.LoginName,
            develiverFr: this.StartDate.Format("yyyy-MM-dd"),
            develiverTo: this.EndDate.Format("yyyy-MM-dd"),
            customerId: this.CustomerId
          }
        })
        .then(response => {
          if (response.status == 200) {
            console.log("gettranswaresummary", response.data);
            this.WHSummaryList = response.data.Data;

            this.TotalCount = 0;
            this.TotalCube = 0;
            this.TotalWeight = 0;

            let Total_Diff = 0;

            this.WHSummaryList.forEach(item => {
              this.TotalCount += item.Total_Count;
              this.TotalWeight += item.Total_Weight;
              this.TotalCube += item.Total_Cube;
              this.CustomerName = item.CustomerName;

              Total_Diff += item.Total_Count_Diff;

              if (item.Record_Count == 0) {
                item.percentage_Rate = 0;
              } else if (item.Record_Count_Received != item.Record_Count) {
                item.percentage_Rate =
                  (item.Record_Count_Received / item.Record_Count) * 100;

                item.percentage_Rate = Number(
                  Number(item.percentage_Rate).toFixed(2)
                );
              } else {
                item.percentage_Rate = 100;
              }

              if (item.Total_Count == 0) {
                item.percentage_Exp = 0;
              } else if (item.Total_Count_Diff != item.Total_Count) {
                item.percentage_Exp =
                  (item.Total_Count_Diff / item.Total_Count) * 100;
                item.percentage_Exp = Number(
                  Number(item.percentage_Exp).toFixed(2)
                );
              } else {
                item.percentage_Exp = 100;
              }
            });

            //完好入仓率：{件数-异常信息（差异数量总和）}/件数  当异常信息中子栏目“退货处理状态”为已结束时，该子栏目的差异数量数据不予统计
            if (this.TotalCount > 0) {
              this.TotalPercent =
                ((this.TotalCount - Total_Diff) / this.TotalCount) * 100;
              if (this.TotalPercent == 100) {
                this.TotalPercent = 100;
              } else {
                this.TotalPercent = Number(
                  Number(this.TotalPercent).toFixed(2)
                );
              }
            } else {
              this.TotalPercent = 100;
            }

            if (this.TotalCube > 0) {
              this.TotalCube = Number(Number(this.TotalCube).toFixed(2));
            }
            if (this.TotalWeight > 0) {
              this.TotalWeight = Number(Number(this.TotalWeight).toFixed(2));
            }

            //千分位
            this.TotalCount = this.TotalCount.toLocaleString();

            //只有体积时，只显示体积
            //2.两个都有就只显示重量
            //3.只有重量，只显示重量
            if (this.TotalWeight > 0) {
              this.TotalCW = Number(this.TotalWeight).toLocaleString() + " kg";
            } else {
              this.TotalCW = Number(this.TotalCube).toLocaleString() + " m³";
            }

            this.ExpRemark =
              this.StartDate.Format("yyyy-MM-dd") +
              "至" +
              this.EndDate.Format("yyyy-MM-dd") +
              "，总发货数量" +
              this.TotalCount +
              "件，总体积" +
              this.TotalCW +
              "，入仓及时率100%,完好入仓率" +
              this.TotalPercent +
              "%";
            let hasExp = false;
            let expInfo = "";
            this.WHSummaryList.forEach(item => {
              if (item.Total_Count_Diff == 0) {
                if (expInfo == "") {
                  expInfo += item.WareHouse;
                } else {
                  expInfo += "," + item.WareHouse;
                }
                hasExp = true;
              }
            });
            if (hasExp) {
              expInfo = ",其中" + expInfo + "无异常";
            }

            let otherExpInfo = "";
            this.WHSummaryList.forEach(item => {
              if (item.Total_Count_Diff > 0) {
                otherExpInfo +=
                  "," + item.WareHouse + "差异" + item.Total_Count_Diff+'件';
              }
            });

            this.ExpRemark += expInfo;
            this.ExpRemark += otherExpInfo;

            this.loading = false;
          } else {
            var strMsg = "";
            response.data.Messages.forEach(element => {
              strMsg += element.Message + "\r\n";
            });
            this.loading = false;
            me.alert(strMsg);
          }
        })
        .catch(function(error) {
          this.loading = false;
          me.alert(error);
        });
    },

    DownloadImage() {
      html2canvas(this.$refs.canvas, {}).then(canvas => {
        let imgUrl = canvas.toDataURL("image/png");
        var eleLink = document.createElement("a");
        eleLink.href = imgUrl;
        eleLink.download = "入仓统计图";
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);
      });
    },
    customColorMethod(percentage) {
      console.log("percentage:", percentage);
      if (percentage == 100) {
        return "#67c23a";
      } else {
        return "#3db9dc";
      }
    },
    customStatus(percentage) {
      console.log("percentage:", percentage);
      if (percentage == 100) {
        return "success";
      } else {
        return "";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/WHSummary/WHSummary.js